import { useMemo } from 'react';

interface UseEngagementTypeProps {
  preferences: any;
}

export const useEngagementType = ({ preferences }: UseEngagementTypeProps) => {
  
  const engagementType = preferences?.engagementType || 'regular';
  
  const derivedTypes = useMemo(() => ({
    isRegularEngagement: engagementType === 'regular',
    isOccasionalEngagement: engagementType === 'occasional',
  }), [engagementType]);

  return {
    engagementType,
    ...derivedTypes,
  };
};
